export const STORAGE_LOCAL = 'local';
export const STORAGE_COOKIE = 'cookie';
